import React from "react";
import PropTypes from "prop-types";

export const GLGIcon = ({ name, size, useFontAwesome, style }) => {

  if (useFontAwesome) {
    return <i className={`ui icon ${name} ${size}`} />;
  }

  return <i className={`ui icon glg-streamline-icon icon-${name} ${size}`} style={style} />;
};

GLGIcon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  useFontAwesome: PropTypes.bool,
  style: PropTypes.object
};

export default GLGIcon;


